var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['core', 'model/base', 'app-common/component/api-call', 'lib/moment'], function(core, BaseModel, apiCall, moment) {
  var DocumentRequestModel;
  return DocumentRequestModel = (function(_super) {

    __extends(DocumentRequestModel, _super);

    function DocumentRequestModel() {
      DocumentRequestModel.__super__.constructor.apply(this, arguments);
    }

    DocumentRequestModel.prototype.defaults = function() {
      return {
        id: null,
        addOnId: null,
        addOnName: null,
        date: null,
        documentName: null,
        documentType: null,
        ledgerAccountId: null,
        ledgerAccountName: null,
        linkedDocumentCreationDate: null,
        linkedDocumentId: null,
        noteForClient: null,
        taxDocumentType: null
      };
    };

    DocumentRequestModel.prototype.associateWithDocument = function(documentId, onSuccess, onFail) {
      var promise, requestId,
        _this = this;
      requestId = this.get('id');
      promise = apiCall('documentrequest', 'request/' + requestId + '/linkDocument?documentId=' + documentId, 'put');
      promise.success(function(res) {
        if (onSuccess) {
          return onSuccess(res);
        }
      });
      return promise.fail(function(err) {
        if (onFail) {
          return onFail(err);
        }
      });
    };

    DocumentRequestModel.prototype.toLabel = function() {
      var name;
      name = this.get('addOnId') ? this.get('addOnName') : this.get('ledgerAccountName');
      return (name != null ? name : this.getDocumentTypeDisplayLabel()) + " | " + this.toMonthYear();
    };

    DocumentRequestModel.prototype.getDocumentTypeDisplayLabel = function() {
      var transformToLabel;
      transformToLabel = function(rawLabel) {
        var processedLabel;
        processedLabel = rawLabel.toLowerCase().replace(/_/g, ' ');
        return processedLabel.charAt(0).toUpperCase() + processedLabel.slice(1);
      };
      if (this.get('documentType') === 'TAX') {
        return transformToLabel(this.get('taxDocumentType'));
      } else {
        return transformToLabel(this.get('documentType'));
      }
    };

    DocumentRequestModel.prototype.toMonthYear = function() {
      var momentVal;
      momentVal = moment(this.get('date'));
      return momentVal.month() + 1 + "-" + momentVal.year();
    };

    return DocumentRequestModel;

  })(BaseModel);
});
